import {
  Button, Col, Flex, Row
} from "antd";
import Container from "../container";
import classes from "./howItWorks.module.css";
import { useNav } from "../../hooks/useNav";

export const HowItWorksContent = () => {
  const { navExperts } = useNav();

  return (
    <div>
      <Row gutter={[32, 16]} align="stretch">
        <Col span={24} lg={8}>
          <Flex
            vertical
            align="center"
            className="text-center h-full"
          >
            <Flex align="center" justify="center" className={classes.icon}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 121.28 121.28">
                <circle cx="60.64" cy="60.64" r="60.64" fill="#345d9d"/>
                <path d="M88,79.96v3.13c0,3.24-2.63,5.86-5.86,5.86h-42.99c-3.24,0-5.86-2.63-5.86-5.86v-3.13c0-9.06,7.35-16.41,16.41-16.41,3.52,0,5.19,1.95,10.94,1.95s7.44-1.95,10.94-1.95c9.06,0,16.41,7.35,16.41,16.41ZM82.13,79.96c0-5.81-4.74-10.55-10.55-10.55-1.8,0-4.63,1.95-10.94,1.95s-9.16-1.95-10.94-1.95c-5.81,0-10.55,4.74-10.55,10.55v3.13h42.99v-3.13ZM43.05,44.01c0-9.71,7.88-17.59,17.59-17.59s17.59,7.88,17.59,17.59-7.88,17.59-17.59,17.59-17.59-7.88-17.59-17.59ZM48.91,44.01c0,6.46,5.26,11.72,11.72,11.72s11.72-5.26,11.72-11.72-5.26-11.72-11.72-11.72-11.72,5.26-11.72,11.72Z" fill="#fff"/>
              </svg>
            </Flex>
            <div className={classes.content}>
              <h3 className={classes.title}>Scegli il tuo Psiconcologo</h3>
              <p className={classes.text}>
                Seleziona dal nostro team di psiconcologi certificati,
                con anni di esperienza nel supporto psicologico legato
                alla malattia oncologica. In alternativa compila il
                questionario e ne sceglieremo uno per te.
              </p>
            </div>
          </Flex>
        </Col>
        <Col span={24} lg={8}>
          <Flex
            vertical
            align="center"
            className="text-center h-full"
          >
            <Flex align="center" justify="center" className={classes.icon}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 121.28 121.28">
                <circle cx="60.64" cy="60.64" r="60.64" fill="#345d9d"/>
                <path d="M88,41.27v42.99c0,3.24-2.62,5.86-5.86,5.86h-42.99c-3.24,0-5.86-2.62-5.86-5.86v-42.99c0-3.24,2.62-5.86,5.86-5.86h5.86v-6.35c0-.81.66-1.47,1.47-1.47h4.88c.81,0,1.47.66,1.47,1.47v6.35h15.63v-6.35c0-.81.66-1.47,1.47-1.47h4.88c.81,0,1.47.66,1.47,1.47v6.35h5.86c3.24,0,5.86,2.62,5.86,5.86ZM82.13,83.53v-36.4h-42.99v36.4c0,.4.33.73.73.73h41.52c.4,0,.73-.33.73-.73ZM57.57,76.99c-.57.57-1.5.57-2.07,0l-9.17-9.25c-.57-.57-.57-1.5,0-2.07l2.77-2.75c.57-.57,1.5-.57,2.07,0l5.39,5.43,13.57-13.46c.57-.57,1.5-.57,2.07,0l2.75,2.77c.57.57.57,1.5,0,2.07l-17.38,17.24Z" fill="#fff"/>
              </svg>
            </Flex>
            <div className={classes.content}>
              <h3 className={classes.title}>
                Prenota l&apos;appuntamento
              </h3>
              <p className={classes.text}>
                Scegli una data disponibile con il professionista
                scelto e prenota la tua consulenza.
                Il primo incontro è completamento gratuito
              </p>
            </div>
          </Flex>
        </Col>
        <Col span={24} lg={8}>
          <Flex
            vertical
            align="center"
            className="text-center h-full"
          >
            <Flex align="center" justify="center" className={classes.icon}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 121.28 121.28">
                <circle cx="60.64" cy="60.64" r="60.64" fill="#345d9d"/>
                <path d="M99.72,44.41v31.23h-7.82c-2.14,0-3.88-1.73-3.9-3.87h-7.07c-.22,1-.65,1.97-1.33,2.81l-3.2,3.94c-1.93,2.37-5.12,3.11-7.82,2.05-1.65,2.03-3.74,2.93-5.96,2.93-1.84,0-3.49-.62-5.02-1.94-3.88,2.67-9.12,2.6-12.9-.46l-10.33-9.33h-1.11c-.01,2.14-1.75,3.87-3.9,3.87h-7.82v-31.23h14.41l5.81-5.81c1.28-1.27,3.03-1.99,4.84-1.99h27.7c1.88,0,3.59.76,4.84,1.99l5.81,5.81h14.75ZM29.37,69.78c0-1.07-.88-1.95-1.95-1.95s-1.95.88-1.95,1.95.88,1.95,1.95,1.95,1.95-.87,1.95-1.95ZM74.9,69.51l-13.21-10.72-1,.92c-4.92,4.49-10.59,1.44-12.4-.54-3.26-3.54-3.05-9.09.54-12.37l4.73-4.34h-6.92c-.24.1-.45.18-.7.28l-7.54,7.52h-5.12v15.65h3.38l11.88,10.75c1.97,1.6,5.06,1.28,6.75-.81l1.91-2.34,4.49,3.85c.37.29,1.47.6,2.2-.29l3.66-4.46,2.92,2.37c.43.34,1.04.27,1.38-.15l3.19-3.93c.33-.42.27-1.04-.15-1.38ZM88,50.27h-5.46l-7.54-7.52c-.17-.18-.42-.28-.67-.28l-10.22.02c-1.22,0-2.39.45-3.3,1.28l-8.01,7.34c-1.18,1.07-1.28,2.93-.15,4.14,1.09,1.15,3.07,1.06,4.23,0l6.74-6.18c.79-.72,2.03-.67,2.76.12l1.33,1.43c.73.79.67,2.03-.12,2.76l-1.53,1.39,12.54,10.19c.34.28.66.6.94.94h8.45v-15.63ZM95.81,69.78c0-1.07-.88-1.95-1.95-1.95s-1.95.88-1.95,1.95.88,1.95,1.95,1.95,1.95-.87,1.95-1.95Z" fill="#ffffff"/>
              </svg>
            </Flex>
            <div className={classes.content}>
              <h3 className={classes.title}>
                Inizia il tuo percorso di supporto
              </h3>
              <p className={classes.text}>
                Potrai iniziare subito il tuo percorso di sostegno
                un&apos;opportunità in più per meglio personalizzare
                il teleconsulto secondo le tue esigenze.
              </p>
            </div>
          </Flex>
        </Col>
      </Row>
      <Flex justify="center" style={{ marginTop: 24 }} >
        <Button type="primary" size="large" onClick={navExperts} className="px-[48px]">Prenota la tua visita</Button>
      </Flex>
    </div>
  );
};

const HowItWorks = () => {
  return (
    <div className="bg-themeGray">
      <Container className="pt-[3rem] pb-[3rem]">
        <h2 className="heading text-center">
          Come funziona
        </h2>
        <HowItWorksContent/>
      </Container>
    </div>
  );
};

export default HowItWorks;
